import React, { useState } from "react";

const FAQ_ITEMS = [
  {
    q: "Ben yolculuk yaparken bana sürekli yeni çağırı düşüyor, almak istemiyorsam Pro seviyemi düşürmeden ne yapmalıyım?",
    a: `⚠️ Eğer yeni sipariş almak istemiyorsanız, lütfen yolcu taşırken “çevrimdışı” moda geçin.
Böylece çağrı gelmez ve puan da düşmez.`,
  },
  {
    q: "Paramı kendi IBAN’ıma nasıl aktarabilirim?",
    a: `Paranızı kendiniz IBAN’a aktarabilirsiniz. İşte adımlar:

⿡ Profilinizdeki IBAN (TR ile başlayan) büyük harflerle ve doğru şekilde yazılmalı.
📝 İsim-Soyisim, bankadakiyle aynı olmalı.

⿢ Bakiye sayfasına girin ve "Para Çek" butonuna tıklayın.

⿣ Açılan sayfada, ₺0 yazan yerin altındaki SiPay simgesine tıklayın → IBAN’ı seçin.

⿤ ₺0 yerine istediğiniz miktarı yazın ve şirketten talep gönderin.

⿥ Ardından bankadan “para geldi” bildirimi bekleyin.

📩 Eğer para gelmezse, bize yazabilirsiniz – yardımcı olurum.`,
  },
  {
    q: "Ödeme ilgili bilgi alabilir miyim?",
    a: `💸 Ödeme Bilgisi:

Papara hesabınız varsa → Her gün sabah 09:00–10:00 arasında otomatik ödeme yapılır

Diğer banka IBAN’ı varsa →
Profil → Bakiye → Para ÇEK kısmından istediğiniz zaman aktarabilirsiniz

IBAN seçili olduğundan emin olun

İşlem ücreti: 6 TL`,
  },
  {
    q: "Yolcunun adresi değişirse ne yapılmalı?",
    a: `Yolcu, önceden belirttiği yerden 300 metreden fazla erken inmek istiyorsa:
→ Kendi uygulamasından gideceği adresi değiştirmeli
→ Size “Rota değişti” mesajı gelir
→ Yeni rotayı kabul edin ve yolculuğu tamamlayın

Yolcu, gitmek istediği yeri uzatmak istiyorsa:
→ Uygulamasından yeni adresi girmeli`,
  },
  {
    q: "Puan Sistemi Nasıldır?",
    a: `Başlangıçta 100 Pro puan verilir

Ne kadar çok puan → o kadar çok sipariş!

📈 Puan artar:
✔️ Yolculuğu sorunsuz bitirdiğinizde

📉 Puan düşer:
❌ Çağrıyı reddederseniz
❌ Kabul edip iptal ederseniz → daha fazla düşer`,
  },
  {
    q: "Müşteri yok veya cevap vermiyor ne yapmalıyım?",
    a: `📍 Müşteri yoksa veya cevap vermiyorsa:
→ Ekranda “bekleme süresi” görününceye kadar noktada bekleyin, puan kesilmez`,
  },
  {
    q: "Müsait değilim, çağırı alamıyorum puan düşürmemek için ne yapmalıyım?",
    a: `🚫 Müsait değilseniz mutlaka “çevrimdışı” moda geçin!`,
  },
  {
    q: "Hedef bonusum neden yatmadı?",
    a: `Sayın şoförler,
Yandex sisteminde servis kurallarına uyulmadan yapılan yolculuklar arttığı için:

🎯 Hedef tamamlama bonusları, önce Yandex’in güvenlik sistemi tarafından kontrol edilir.
🔍 Her şey uygunsa, bonus hesabınıza aktarılır.

⏳ Lütfen sistemin inceleme sürecini bekleyin.`,
  },
];

export default function FaqPage() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div style={{ padding: 24, maxWidth: 1200 }}>
      <div style={{ marginBottom: 10, color: "#374151", fontWeight: 700 }}>
        Sürücülerin çok popüler sorularının yanıtları:
      </div>

      <div style={{ display: "grid", gap: 10 }}>
        {FAQ_ITEMS.map((item, i) => {
          const open = openIndex === i;
          return (
            <div
              key={item.q}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                background: "#fff",
                overflow: "hidden",
              }}
            >
              <button
                type="button"
                onClick={() => setOpenIndex(open ? -1 : i)}
                style={{
                  width: "100%",
                  border: "none",
                  background: "#fff",
                  padding: "14px 16px",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  fontWeight: 900,
                  color: "#111827",
                  fontSize: 20,
                }}
              >
                <span>{item.q}</span>
                <span style={{ color: "#6b7280", fontSize: 16 }}>{open ? "▴" : "▾"}</span>
              </button>

              {open ? (
                <div
                  style={{
                    borderTop: "1px solid #f1f5f9",
                    padding: "14px 16px 16px",
                    color: "#374151",
                    lineHeight: 1.6,
                    whiteSpace: "pre-wrap",
                    fontWeight: 600,
                  }}
                >
                  {item.a}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
